import { useState } from 'react';
import { z } from 'zod';
import { apiFetch } from '@/lib/api-client';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { mapApiError } from '@/lib/error-map';

export function ConsultaPage() {
  const [cedula, setCedula] = useState('');
  const [error, setError] = useState<string | undefined>();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(undefined);
    setLoading(true);
    try {
      // Validación local (mismo regex que backend)
      if (!/^\d{6,10}$/.test(cedula)) {
        throw new Error('Cédula inválida (6-10 dígitos)');
      }
      await apiFetch('/auth/forgot-qr', z.unknown(), {
        method: 'POST',
        body: JSON.stringify({ cedula }),
      });
      setSent(true);
    } catch (e) {
      setError(mapApiError(e));
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg p-4">
        <div className="w-full max-w-sm border border-border bg-bg-elevated p-6 text-center">
          <h1 className="text-2xl font-bold">Revisa tu correo</h1>
          <p className="mt-2 text-sm text-text-secondary">
            Si tu cédula está registrada, te enviamos un enlace con tu credencial. El enlace expira en 15
            minutos.
          </p>
          <button
            type="button"
            onClick={() => {
              setSent(false);
              setCedula('');
            }}
            className="mt-4 text-sm text-primary hover:underline"
          >
            ← Volver
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-3 border border-border bg-bg-elevated p-6"
        noValidate
      >
        <h1 className="text-2xl font-bold">Consulta tu credencial</h1>
        <p className="text-sm text-text-secondary">
          Ingresa tu cédula y te enviaremos un enlace por email.
        </p>
        <div>
          <Label htmlFor="cedula">Cédula</Label>
          <Input
            id="cedula"
            inputMode="numeric"
            pattern="\d{6,10}"
            value={cedula}
            onChange={(e) => setCedula(e.target.value)}
            aria-invalid={Boolean(error)}
          />
        </div>
        {error && (
          <p role="alert" className="rounded-md bg-destructive/10 p-2 text-sm text-destructive">
            {error}
          </p>
        )}
        <Button type="submit" disabled={loading} className="w-full">
          {loading ? 'Enviando…' : 'Enviar enlace a mi email'}
        </Button>
      </form>
    </div>
  );
}